import type { TrackWorkRpaDesktopRequiredShown } from '@heidi/agents/contracts';

import { getWorkHostPort } from '../../work-home/work-home-ports';

/**
 * Shared friction event when web Work blocks a computer-use action that needs
 * the desktop RPA bridge. Datadog only — Amplitude, PostHog and Snowplow stay
 * off. The pipeline is the shell `track` port; this module keeps the payload.
 */
export const trackWorkRpaDesktopRequiredShown: TrackWorkRpaDesktopRequiredShown = ({
  surface,
  blockedAction,
  action,
}) => {
  const shell = getWorkHostPort('shell');
  shell.track({
    event_name: 'work_rpa_desktop_required_shown',
    props: {
      surface,
      region: shell.getRegion(),
      blocked_action: blockedAction,
      ...(action ? { action } : {}),
    },
    options: { amplitude: false, posthog: false, snowplow: false },
  });
};
